import { EventEmitter } from 'eventemitter3';
import axios from 'axios';
import { API_PATH } from '../../config/config';

export default class ArticleService {
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return this._instance = new ArticleService();
    }

    constructor() {
        this.events = new EventEmitter;
    }

    getHowTo() {
        return axios.get(API_PATH + `/doc/v1/public/article/minimal/HOW_TO`);
    }

    getListByIds(ids) {
        return axios.post(API_PATH + '/doc/v1/public/article/resume/list', { ids });
    }

	getTermsAndConditions() {
		return axios.get(API_PATH + '/doc/v1/public/article/code/terms-and-conditions');
	}

	getIndexLandingArticle() {
		return axios.get(API_PATH + '/doc/v1/public/article/type/HOME_PAGE');
	}

	getArticlesMinimal(type) {
		return axios.get(API_PATH + `/doc/v1/public/article/minimal/${type}`);
	}
}